export function includeInShareImage(node: Node): boolean {
	if (!(node instanceof Element)) return true;
	if (node.tagName.toLowerCase() === 'video' || node.classList.contains('rich-text-video-widget')) return false;
	if (node.querySelector('video')) {
		const content = node.cloneNode(true) as Element;
		content.querySelectorAll('video').forEach((video) => video.remove());
		if (!content.textContent?.trim() && !content.querySelector('img,canvas,svg,iframe')) return false;
	}
	return true;
}

export function cloneWithoutShareVideos(element: HTMLElement): HTMLElement {
	const clone = element.cloneNode(true) as HTMLElement;
	for (const video of Array.from(clone.querySelectorAll('video'))) {
		let target: Element = video;
		while (target.parentElement && target.parentElement !== clone && !includeInShareImage(target.parentElement)) {
			target = target.parentElement;
		}
		target.remove();
	}
	return clone;
}
